const config = {
  API_BASE_URL: process.env.REACT_APP_API_BASE_URL || 'https://adisa-api.herokuapp.com',
  BASE_URL: process.env.REACT_APP_BASE_URL || 'https://adisa.com.ua',
  RECAPTCHA_PUBLIC_KEY: process.env.REACT_APP_RECAPTCHA_PUBLIC_KEY || '6Lf1pgUcAAAAAG9yY6Caem6ypoyyDxwtiSkD4qmM'
};

export default config;
